import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// No global functionMiddleware: the site has no accounts, so there is no session
// token to attach — and importing the Supabase client here would pull ~200KB of
// auth/realtime code into every page's entry chunk. Supabase is loaded lazily, at
// submit time, by the contact form.
export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
}));
